// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yc1u","colMin":"styles_colMin__YemDl"};